// extracted by mini-css-extract-plugin
module.exports = {"tabProfile":"Profile_tabProfile__vj7He","navbarContent":"Profile_navbarContent__2yZ31","navActive":"Profile_navActive__17xWx"};